// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"qo-z","badgeLink":"ro-z","category":"so-z"};